module.exports = __webpack_public_path__ + "img/1.8d8a3f46.png";